import { Repository, EntityRepository, Raw } from 'typeorm';
import { PlaceListItems } from './place_list_items.entity';


@EntityRepository(PlaceListItems)
export class PlaceListItemsRepository extends Repository<PlaceListItems>{

}